import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import { Section, Container, SectionTitle } from 'chaoskit/src/components'

import { getAlgoliaIndexName } from '../../utils/helpers'

import { sectionSeparator } from '~styles/utility'
import { CustomInfiniteHits } from '~partials/search/algolia-global'
import { Hit } from '~partials/search/algolia-resources'
import useAlgoliaSearchClient from '~hooks/useAlgoliaSearchClient'

const { algoliaIndex } = getAlgoliaIndexName()

const FilteredContent = ({
  facetFilters,
  filters,
  heading,
  hideSeparator,
  ...rest
}) => {
  const theme = useTheme()

  const searchClient = useAlgoliaSearchClient((state) => state.searchClient)

  return (
    <Section
      space="xlarge"
      css={[
        !hideSeparator &&
          sectionSeparator(theme, {
            start: theme.color.info.base,
            stop: theme.color.primary.base,
          }),
      ]}
      {...rest}
    >
      <Container>
        <SectionTitle as="h2" title={heading} />
        <InstantSearch indexName={algoliaIndex} searchClient={searchClient}>
          <Configure
            filters={filters}
            facetFilters={facetFilters}
            hitsPerPage="3"
          />
          <CustomInfiniteHits
            moreText="Load more articles"
            hitTemplate={Hit}
            customCss={{
              [theme.mq.small]: {
                gridTemplateColumns: 'repeat(2, 1fr)',
              },

              [theme.mq.medium]: {
                gridTemplateColumns: 'repeat(3, 1fr)',
              },
            }}
          />
        </InstantSearch>
      </Container>
    </Section>
  )
}

FilteredContent.propTypes = {
  heading: PropTypes.string.isRequired,
  /** facetFilters={[['topics:Retail', 'topics:SaaS']]} */
  facetFilters: PropTypes.array,
  filters: PropTypes.string,
  hideSeparator: PropTypes.bool,
}

export default FilteredContent
